module.exports = __webpack_public_path__ + "static/media/Lignes_Directrices_2_01juin2025CSA.a25e52b4.pdf";